export const SET_TENANT = 'SET_TENANT';
export const SET_TENANT_BRANDING = 'SET_TENANT_BRANDING';


export const FETCH_TENANT_UPCOMING_APPOINTMENTS_EXTRA_OPTIONS_REQUEST = "FETCH_TENANT_UPCOMING_APPOINTMENTS_EXTRA_OPTIONS_REQUEST";
export const FETCH_TENANT_UPCOMING_APPOINTMENTS_EXTRA_OPTIONS_SUCCESS = "FETCH_TENANT_UPCOMING_APPOINTMENTS_EXTRA_OPTIONS_SUCCESS";
export const FETCH_TENANT_UPCOMING_APPOINTMENTS_EXTRA_OPTIONS_ERROR = "FETCH_TENANT_UPCOMING_APPOINTMENTS_EXTRA_OPTIONS_ERROR";
